import backendHttpClient from '../../../http/axios/axios-http-client';
import { RecommendedHealers } from '../healer-selection/dto/recommended-healers';

const PUBLIC_HEALER_SELECTION_ENDPOINT = '/public/healers-recommendation';

export interface MySelectionsGateway {
  getAllHealerRecommendationForClient(clientUserProfileId?: string): Promise<RecommendedHealers[]>;
}

export class MySelectionsGateway implements MySelectionsGateway {
  async getAllHealerRecommendationForClient(clientUserProfileId?: string): Promise<RecommendedHealers[]> {
    const endpoint = `${PUBLIC_HEALER_SELECTION_ENDPOINT}/history/${clientUserProfileId}`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }
}
